import React from 'react';
import { useTranslation } from 'react-i18next';

import { AddOnData } from '../add-ons';
import { Card } from './card';
import { TerrainModelContent } from './terrain-model-content';

type Props = {
  onChange: (data: AddOnData) => void;
  selected: boolean;
};

const TerrainModelCard = (props: Props) => {
  const { t } = useTranslation('cloudProcessing');
  const [selected, setSelected] = React.useState(props.selected);

  const onToggle = () => {
    setSelected(!selected);
    props.onChange({ terrainModel: { enabled: !selected } });
  };

  return (
    <Card
      selected={selected}
      title={t('setupDialog.addOns.terrainModel.cardTitle', { ns: 'cloudProcessing' })}
      onClick={onToggle}
    >
      <TerrainModelContent selected={selected} />
    </Card>
  );
};

export { TerrainModelCard };
